import { Component, OnInit } from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {
  AttributeManipulationGroupsApiService
} from '../../../services/api/settings/call-flow-configurations/attribute-manipulation-groups/attribute-manipulation-groups-api.service';
import {
  GlobalPreRoutingManipulationApiService
} from '../../../services/api/settings/call-flow-configurations/global-pre-routing-manipulation/global-pre-routing-manipulation-api.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';

@Component({
  selector: 'normalization-before-routing',
  templateUrl: './normalization-before-routing.component.html',
  styleUrls: ['./normalization-before-routing.component.scss']
})
export class NormalizationBeforeRoutingComponent implements OnInit {

  manipulationGroups: any = [];
  globalPreRoutingManipulation: any = {};
  canSubmit;

  constructor(private userPrivilege: UserPrivilegeService,
              private attributeManipulationGroupsApiService: AttributeManipulationGroupsApiService,
              private globalPreRoutingManipulationApiService: GlobalPreRoutingManipulationApiService,
              private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.initialization();
  }

  initialization(): void {
    this.loaderService.showMainContainer();
    this.canSubmit = this.userPrivilege.isAuthorized();

    this.attributeManipulationGroupsApiService.getAttributeManipulationGroups().subscribe(manipulationGroups => {
      this.manipulationGroups = manipulationGroups;
      this.manipulationGroups.unshift({id: -1, groupName: ''});
      this.initialiseGroupsSelection();
    });
  }

  initialiseGroupsSelection(): void {
    this.globalPreRoutingManipulationApiService.getGlobalPreRoutingManipulation().subscribe(globalPreRoutingManipulation => {
      this.globalPreRoutingManipulation = globalPreRoutingManipulation;
      this.loaderService.hideMainContainer();
    });
  }

  submit(): void {
    this.globalPreRoutingManipulationApiService.editGlobalPreRoutingManipulation(this.globalPreRoutingManipulation).subscribe();
  }


}
